export /**
 *
 * Returns a capitalized string
 * @param {string} input
 * @return {string}
 */
const capitalizeString = (input) => {
  if (!input) {
    return "";
  }
  if (typeof input !== "string") {
    return (
      input.toString().charAt(0).toUpperCase() + input.toString().substring(1)
    );
  }
  return input.charAt(0).toUpperCase() + input.substring(1);
};
